
















































































































































































































































































































import { Vue, Component } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import DateOption from '@/mixins/dateOption'
import { formatJson, resetObjValue2NoneString } from '@/utils/tool'
import { getNoticeList, deleteNotice } from '@/api/content/content-notice/notice'
import Sortable from 'sortablejs'

const classifyList = [
  {
    id: '1',
    name: '热门'
  },
  {
    id: '2',
    name: '流行'
  }
]

const tableData = [
  {
    id: 1,
    title: '重要通知',
    content: '哈哈哈哈哈哈哈啊哈',
    language: 'Zh',
    type: '官网',
    status: '是',
    link: 'http://xxx.com',
    displayDateStart: '2019/08/25 14:54:00',
    displayDateEnd: '2020/08/25 14:54:00',
    updateDate: '2019/08/25 14:54',
    editor: 'huhua'
  },
  {
    id: 2,
    title: '重要通知',
    content: '哈哈哈哈哈哈哈啊哈',
    language: 'Zh',
    type: '官网',
    status: '是',
    link: 'http://xxx.com',
    displayDateStart: '2019/08/25 14:54:00',
    displayDateEnd: '2020/08/25 14:54:00',
    updateDate: '2019/08/25 14:54',
    editor: 'huhua'
  }
]
@Component({
  name: 'PushList'
})
export default class extends mixins(DateOption) {
  params = {
    id: '',
    title: '',
    content: '',
    type: '',
    language: '',
    status: '',
    editor: '',
    displayDateStart: '',
    displayDateEnd: '',
    updateDateStart: '',
    updateDateEnd: '',
    page: 1,
    pageCount: 20
  }
  tableLoading = false
  tableData: any[] = []
  selectedData: any[] = []
  classifyList = classifyList
  dateArray: string[] = ['', '']
  updateDateArray: string[] = ['', '']
  totalCount = 0
  routeQuery: IQuery = { id: 0, platform: 'ios' }
  typeMap: string[] = ['全局', 'PC端', '移动端', 'iOS', '安卓官网']
  addFormVisible: boolean = false
  addParams: any = {
    title: ''
  }
  destinations: any[] = [
    {
      label: 'link',
      text: '链接'
    }, {
      label: 'browser',
      text: '浏览器打开'
    }, {
      label: 'app-detail',
      text: 'APP详情页'
    }, {
      label: 'special',
      text: '专题页'
    }
  ]
  tableHeight: number = 500
  openWindow: any

  created() {
    // this.getTableData()
    this.$nextTick(() => {
      this.setTableHeight()
      window.addEventListener('resize', this.setTableHeight)
    })
  }
  mounted() {
    this.rowDrop()
  }
  beforeDestroy() {
    window.removeEventListener('resize', this.setTableHeight)
  }

  setTableHeight() {
    const filter: any = this.$refs.filter
    const filterDom: any = filter.$el
    this.tableHeight = document.body.clientHeight - 250 - filterDom.clientHeight
  }

  rowDrop() {
    const table = document.querySelector('.el-table__body-wrapper tbody')
    const _this = this
    // table 有值时才能对其进行操作
    if (table) {
      Sortable.create(table, {
        handle: '.drag-icon',
        onEnd({ oldIndex, newIndex }: any) {
          if (oldIndex !== newIndex) {
            console.log(oldIndex, newIndex)
          }
        }
      })
    }
  }

  async getTableData() {
    this.tableLoading = true
    // this.tableData = tableData
    const res: any = await getNoticeList(this.params)
    const { dataList, pageInfo } = res.data
    this.totalCount = pageInfo.totalCount
    this.tableData = dataList
    this.tableLoading = false
  }

  handleDateChange(date: string[] | any) {
    this.params.displayDateStart = date && date[0]
    this.params.displayDateEnd = date && date[1]
  }
  handleUpdateDateChange(date: string[] | any) {
    this.params.updateDateStart = date && date[0]
    this.params.updateDateEnd = date && date[1]
  }
  handleSearch() {
    if (this.tableLoading) { return false }
    let params:any = { ...this.params }
    for (let i in params) {
      if (typeof params[i] === 'string') {
        params[i] = params[i].trim()
      }
    }
    this.params = params
    this.params.page = 1
    this.getTableData()
  }
  handleReset() {
    resetObjValue2NoneString(this.params, ['page', 'pageCount'])
    this.params.page = 1
    this.dateArray = ['', '']
    this.getTableData()
  }
  handleAdd() {
    this.addFormVisible = true
  }
  handleEdit(item: any) {
    this.addFormVisible = true
  }

  cancelAddForm() {}
  confirmAddForm() {}

  handleSelectionChange(list: any[]) {
    this.selectedData = list
  }
  handleSelectAll() {
    // 如果没有选择全部, 则寻找未选择的行, 并将这些行选中
    if (this.selectedData.length < this.tableData.length) {
      let tempSelectList = this.selectedData.map(item => item.id)
      let unSelected: any[] = this.tableData.filter((item: any) => !tempSelectList.includes(item.id))
      unSelected.forEach(row => {
        (this.$refs['multiTable'] as any).toggleRowSelection(row)
      })
    } else {
      (this.$refs['multiTable'] as any).clearSelection()
    }
  }
  handleSelectReverse() {
    this.selectedData = []
    let tempList: number[] = []
    let tempSelectList: number[] = []
    let indexList: number[] = []
    tempList = this.tableData.map(item => item.id)
    tempSelectList = this.selectedData.map(item => item.id)
    indexList = tempList.filter(item => !tempSelectList.includes(item))
    this.tableData.forEach(item => {
      if (indexList.includes(item.id)) this.selectedData.push(item)
    })
    if (this.selectedData.length) {
      this.selectedData.forEach(row => {
        (this.$refs['multiTable'] as any).toggleRowSelection(row)
      })
    } else {
      (this.$refs['multiTable'] as any).clearSelection()
    }
  }
  handleDeleteAll() {
    // this.setAccount(type, this.selectIds)
  }
  handleExcel() {
    // let res: any = await getIosList({
    //   page: 1,
    //   pageCount: 3000
    // })
    // if (res.status.code === 0) {
    //   this['$message'].success('导出成功')
    // } else {
    //   this['$message'].error('导出失败')
    //   return
    // }
    // const filterVal: string[] = [
    //   'id',
    //   'name',
    //   'developer',
    //   'category',
    //   'source',
    //   'version',
    //   'price',
    //   'socre',
    //   'status',
    //   'editor',
    //   'updateDate'
    // ]
    // const theader: string[] = [
    //   'ID',
    //   '名称',
    //   '开发者',
    //   '类别',
    //   '来源',
    //   '版本',
    //   '价格',
    //   '评分',
    //   '应用状态',
    //   '编辑人',
    //   '最后修改时间'
    // ]
    // const list = res.data.dataList
    // const data = formatJson(filterVal, list)
    // exportJson2Excel(theader, data)
  }

  // computed
  get showMultiSelect() {
    return this.selectedData.length > 1
  }
  get selectCount() {
    return this.selectedData.length
  }
  get selectIds() {
    let t: number[] = []
    this.selectedData.forEach(item => {
      t.push(item.id)
    })
    let ids = t.join(',')
    return ids
  }

  handleDelete(item: any) {
    this.$confirm('确认删除该数据?', '提示', {
      confirmButtonText: '确认',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(async() => {
        let res: any = await deleteNotice({
          ids: item.id
        })
        if (res.status.code === 0) {
          this['$message'].success('删除成功')
          this.getTableData()
        } else {
          this['$message'].error('删除失败')
        }
      })
      .catch(() => {})
  }
}
